import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import ActiveRegister from "../components/cashRegister/active";
import ClosedRegister from "../components/cashRegister/closed";
import Skeleton from "../components/common/skeleton.comp";
import PosLayout from "../components/layouts/posLayout.comp";
import { getAdminInfo } from "../core/admin.core";
import { posCashRegisterCore } from "../core/cashRegister";
import { useTranslation } from "../core/translation.core";
import ErrorCenterIcon from "../icons/exclamationTriangleCenter.icon";
import Link from "next/link";
import HistoryIcon from "../icons/history.icon";

export default function CashRegisterPage() {
  return (
    <PosLayout title="Cash Register">
      <div className="text-black dark:text-white space-y-10">
        <Content />
      </div>
    </PosLayout>
  );
}

function Content() {
  const { msg, t } = useTranslation();
  const queryClient = useQueryClient();

  const { data: me } = useQuery({
    queryFn: () => getAdminInfo(),
    queryKey: ["admin"],
  });

  async function openRegister() {
    await posCashRegisterCore
      .open({
        openedBy: me.email,
      })
      .then(() => {
        queryClient.invalidateQueries({ queryKey: ["cash-register"] });
      })
      .catch(() => {
        toast.error(t(msg.errors.contactAdmin));
      });
  }

  const { data, isError, isFetched, failureReason } = useQuery({
    queryFn: () => posCashRegisterCore.list(),
    queryKey: ["cash-register"],
  });

  if (isError) return <ErrorCenterIcon reason={failureReason} />;
  if (!isFetched) return <Skeleton />;

  const allClosed = data?.data?.every((item) => item.status === "closed");
  return (
    <main className="space-y-10">
      <div
        className={`${
          allClosed ? "flex gap-6 flex-col lg:flex-row justify-between items-center" : "flex justify-between items-center"
        }`}
      >
        <p className="text-2xl font-semibold tracking-wide">{t(msg.posMenuItems.settlement)}</p>

        <div className="flex gap-5 items-center">
          {allClosed && (
            <button className="px-4 py-2 bg-blue-600 text-white rounded-md" onClick={openRegister}>
              {t(msg.pos.openRegister)}
            </button>
          )}

          <Link
            className="flex gap-2 items-center px-4 py-2 text-blue-600 bg-slate-200 rounded-md"
            href="/settlement/manual-transactions"
          >
            <HistoryIcon />
            {t(msg.pos.viewHistory)}
          </Link>
        </div>
      </div>

      <section className="space-y-10">
        {data?.data?.map((item) => (
          <div key={item._id}>
            {item.status === "open" || item.status === "startClosing" ? (
              <ActiveRegister item={item} />
            ) : (
              <ClosedRegister item={item} />
            )}
          </div>
        ))}
      </section>
    </main>
  );
}
